import { create } from '@wix/fedops-logger';
import _ from 'lodash';

interface IFedopsLogger {
  interactionStarted(name: string): void;
  interactionEnded(name: string): void;
  appLoaded(): void;
}

function createFakeLogger(): IFedopsLogger {
  return {
    interactionStarted: _.noop,
    interactionEnded: _.noop,
    appLoaded: _.noop,
  };
}

export const fedopsLogger: IFedopsLogger = window.__USE_TRACKERS__
  ? create('media-platform-client')
  : createFakeLogger();
